import _ from 'lodash';
import { paginationSize } from '../../../constants/constants';
import { ADD_UPDATE_USER_CASE_SUCCESS, DELETE_USER_CASE_SUCCESS, FETCH_MY_LIBRARY_USER_CASES_ERROR, FETCH_MY_LIBRARY_USER_CASES_START, FETCH_MY_LIBRARY_USER_CASES_SUCCESS, FETCH_REPORT_USER_CASE_ERROR, FETCH_REPORT_USER_CASE_SUCCESS, MY_LIBRARY_PAGINATION, SET_MY_LIBRARY_FILTER } from "../../actions/LibraryAction";

const INIT_STATE = {
    myLibrary: [],
    loading: false,
    message: '',
    error: '',
    myLibraryPagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0
    },
    searchFilter: {
        diagnosis: "",
        description: "",
        tags: ""
    },
    userCase: null
}

export const myLibraryReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    switch (action.type) {
        case FETCH_MY_LIBRARY_USER_CASES_START:
            return { ...state, error: '', message: '', loading: true }

        case FETCH_MY_LIBRARY_USER_CASES_SUCCESS:
            return { ...state, error: '', message: '', loading: false, myLibrary: action.myLibrary.length > 0 ? [...action.myLibrary] : [] }

        case FETCH_MY_LIBRARY_USER_CASES_ERROR:
            return { ...state, loading: false, error: '', myLibrary: [] }

        case MY_LIBRARY_PAGINATION: {
            return { ...state, myLibraryPagination: action.pagination };
        }
        case SET_MY_LIBRARY_FILTER: {
            return { ...state, searchFilter: action.searchFilter };
        }
        case ADD_UPDATE_USER_CASE_SUCCESS: {
            let myLibrary = state.myLibrary;
            let index = myLibrary.findIndex(libraryItem => libraryItem.caseId === action.userCase.caseId);
            if (index > -1) {
                myLibrary[index] = _.cloneDeep(action.userCase);
                return { ...state, myLibrary: _.cloneDeep(myLibrary) }
            } else {
                return { ...state }
            }
        }
        case DELETE_USER_CASE_SUCCESS: {
            let myLibrary = state.myLibrary;
            let index = myLibrary.findIndex(libraryItem => libraryItem.caseId === action.caseId);
            if (index > -1) {
                myLibrary.splice(index, 1);
                return { ...state, myLibrary: _.cloneDeep(myLibrary) }
            } else {
                return { ...state }
            }
        }
        case FETCH_REPORT_USER_CASE_SUCCESS: {
            return { ...state, userCase: action.userCase ? action.userCase : null }
        }
        case FETCH_REPORT_USER_CASE_ERROR: {
            return { ...state, userCase: null }
        }

        default:
            return state;
    }
}
export default myLibraryReducer;